const styles = {
  loader: {
    left: '50%',
    marginLeft: '-12px',
    top: '50%',
    marginTop: '-12px',
    position: 'absolute',
  },
};

export default styles;
